module.exports = __webpack_public_path__ + "img/course.fabc0da1.svg";